import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'
import type { IProjectNote } from '../../../Model/Project/IProjectNote.js'

export const UpdateNoteEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.updateNoteRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      return ProjectRepository.updateNote(action.payload.projectId, action.payload.noteId, { content: action.payload.content }).pipe(
        mergeMap((response: IProjectNote[]) => {
          // Find the updated note in the response
          const updatedNote = response.find((note) => note.id === action.payload.noteId)
          if (!updatedNote) {
            throw new Error(`Updated note with ID ${action.payload.noteId} not found in response`)
          }
          return of(
            project.updateNoteRequestSuccess({
              projectId: action.payload.projectId,
              note: updatedNote
            })
          )
        }),
        catchError((error) => of(project.updateNoteRequestFailure({ error })))
      )
    })
  )
